import {FC} from "react";
import Slick from 'react-slick';
import cn from 'classnames'

import slider1 from './img/slider1.jpg'

import classes from './Slider.module.css';

const Slider: FC = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };

    return (
        <Slick {...settings}>
            <div className={cn(classes.item)}>
                <div className={cn(classes.itemBG, classes.slider1)}>
                    <img src={slider1} alt=""/>
                    <h3 className={cn(classes.itemTitle, classes.titleBlack)}>Tarptautinis labdaros fondas "UKRAINSKA GROMADA"</h3>
                </div>
            </div>
            <div className={classes.item}>
                <div className={cn(classes.itemBG, classes.slider2)}>
                    <img src={slider1} alt=""/>
                    <h3 className={cn(classes.itemTitle, classes.titleWhite)}>Pagalba nukentėjusiems nuo katastofų, ginkluotų konfliktų ir nelaimingų atsitikimų, taip pat pabėgėliams ir asmenims, patekusiems į sunkias gyvenimo aplinkybes.</h3>
                </div>
            </div>
            <div className={classes.item}>
                <div className={cn(classes.itemBG, classes.slider3)}>
                    <img src={slider1} alt=""/>
                    <h3 className={cn(classes.itemTitle, classes.titleBlack)}>Pagalbos ir paramos teikimas Ukrainos Ginkluotosioms pajėgoms ir kitoms teisėtoms Ukrainos gynybos formuotėms</h3>
                </div>
            </div>
        </Slick>
    )
}

export default Slider
